import ReturnExchangeFormPage from '@moncler/components/clientService/ReturnExchangeFormPage';
import { configureAccountStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
const store = configureAccountStore();
const ClientServiceExchange = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(ReturnExchangeFormPage, Object.assign({}, props, { orderNumber: null }))));
};
export default ClientServiceExchange;
